module.exports = __webpack_public_path__ + "images/total_small995b188165189a426ed9c9f998893a55.png";